import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectCurrentListing } from '@redux/selectors/ListingSelector';
import { getUserMlsId, getUserName } from '@redux/selectors/UserSelector';
import { getImpersonationStatus } from '@redux/selectors/ImpersonationSelector';
import md5 from 'md5';

import Button from '@components/smartAdminUI/Button';
import showingTimeIcon from '@images/logos/vendor/ShowingTime.png';
import GAEventTracking from '@components/tracking/GAEventTracking';

const ShowingTimeWidget = ({ disabled }) => {
  const currListing = useSelector(selectCurrentListing);
  // eslint-disable-next-line no-unused-vars
  const impersonationStatus = useSelector(getImpersonationStatus);
  const realUserMlsId = useSelector(getUserMlsId);
  const userMlsId = useMemo(() => (impersonationStatus?.ImpersonationActive ? impersonationStatus?.memberMlsId : realUserMlsId), [impersonationStatus]);
  const gaEventTracker = GAEventTracking('User');
  const username = useSelector(getUserName);

  const getDateTimeNowUTC = () => new Date().toISOString();
  const getMD5Signature = () => md5(`${getDateTimeNowUTC() + currListing.ListingID + userMlsId}150535003-T2E8K4`);

  const getCurrentListingAddress = () => {
    const streetNumber = currListing.StreetNumber?.toString() ?? '';
    const streetName = currListing.StreetName;
    const streetSuffix = currListing.StreetSuffix?.toString() ?? '';
    const streetDirSuffix = currListing.StreetDirSuffix?.toString() ?? '';
    return `${streetNumber} ${streetName} ${streetSuffix} ${streetDirSuffix}`;
  };

  const getShowingTimeUrl = () => {
    if (!(currListing && userMlsId)) return null;
    return `https://setup-sso.showingtime.com/config?
            level=listing
            &siteid=${encodeURIComponent('CORE.PILLARNINE.I')}
            &mlsid=${encodeURIComponent('PILLARNINE')}
            &listingid=${encodeURIComponent(currListing.ListingID)}
            &userid=${encodeURIComponent(userMlsId)}
            &laid=${encodeURIComponent(currListing.ListAgentMlsId)}
            &listingoffice=${encodeURIComponent(currListing.ListOfficeMlsId)}
            &paddr=${encodeURIComponent(getCurrentListingAddress())}
            &pcity=${encodeURIComponent(currListing.City)}
            &pstate=${encodeURIComponent(currListing.StateOrProvince)}
            &pzip=${encodeURIComponent(currListing.PostalCode)}
            &price=${encodeURIComponent(currListing.ListPrice?.toString())}
            pstatus=${encodeURIComponent(currListing.StandardStatus)}
            &datetime=${encodeURIComponent(getDateTimeNowUTC())}
            &signature=${encodeURIComponent(getMD5Signature().toUpperCase())}`.replace(/\s/g, '');
  };
  return (
    <div className="panel-content text-center rounded" style={{ backgroundColor: '#000640', minHeight: '231px' }}>
      <img alt="showing-time-icon" src={showingTimeIcon} className="img-fluid mb-3" style={{ height: '60px' }} />
      <p className="mb-5" style={{ color: 'var(--darkText-1)' }}>
        <strong>ShowingTime </strong>
        products automate the showing scheduling and management process, simplify the report generating process, and deliver buyer leads.
      </p>
      <Button
        key="chgShowingTime"
        onClick={() => {
          const url = getShowingTimeUrl();
          if (url) {
            window.open(url, '_blank');
            gaEventTracker('Opened Showing Time', `${username}`);
          }
        }}
        variant="primary"
        disabled={disabled}
      >
        <i className="far fa-external-link mr-2" />
        ShowingTime
      </Button>
    </div>
  );
};

ShowingTimeWidget.propTypes = {
  disabled: PropTypes.bool,
};

export default ShowingTimeWidget;
